(function () {
  "use strict";

  // var handle = (window.__lvCurrentHandle && window.__lvCurrentHandle()) || "";
  // if (handle !== "test-product-3-pack") return;
  if (!window.__lvIsAffiliatePlanAllowedPdp || !window.__lvIsAffiliatePlanAllowedPdp()) {
    return;
  }

  var affiliateCfg = window.__lvGetAffiliatePlanConfig && window.__lvGetAffiliatePlanConfig();
  if (!affiliateCfg) return;

  var FORM_SEL = 'form[action="/cart/add"], form[action="/cart/add/"], form[action*="/cart/add"]';
  var GROUP_SEL = '[data-loop-widget-selling-plan-group][data-selling-plan-group-id]';
  var SELECTED_CLASS = 'loop-widget-purchase-option-selected';
  var PLAN_INPUT_SEL = '[name="selling_plan"], [name="selling_plan_id"], input[name*="selling"][name*="plan"]';

  //   var GROUP_TO_STANDARD_PLAN = {
  //     '268ca8a7e5be636915c23066d5379b8d189eabc9': '2301296691', // 3-month standard
  //     'c4eca92d5e84999762ecf3f0d439cf738ec259b7': '2301263923'  // 1-month standard
  //   };
  var GROUP_TO_STANDARD_PLAN = affiliateCfg.groupToStandard || {};

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function isAffiliateMode() {
    return !!(window.__lvIsAffiliatePricingActive && window.__lvIsAffiliatePricingActive());
  }

  function getForm() {
    return $(FORM_SEL);
  }

  function getHiddenPlanInput(form) {
    return form ? form.querySelector(PLAN_INPUT_SEL) : null;
  }

  function getSelectedGroup() {
    var groups = $$(GROUP_SEL);
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      if (
        g.classList.contains(SELECTED_CLASS) ||
        g.getAttribute('aria-checked') === 'true' ||
        g.getAttribute('aria-selected') === 'true'
      ) {
        return g;
      }
    }
    return null;
  }

  function getPlanIdForSelectedGroup() {
    var selectedGroup = getSelectedGroup();
    if (!selectedGroup) return null;

    var groupId = (selectedGroup.getAttribute('data-selling-plan-group-id') || '').trim();
    if (!groupId) return null;

    var standardPlanId = GROUP_TO_STANDARD_PLAN[groupId];
    if (!standardPlanId) return null;

    if (isAffiliateMode() && window.__lvMapSellingPlanId) {
      return window.__lvMapSellingPlanId(standardPlanId, 'to_affiliate');
    }

    return standardPlanId;
  }

  function syncSellingPlanInput() {
    var form = getForm();
    var hidden = getHiddenPlanInput(form);
    if (!form || !hidden) return;

    var nextPlanId = getPlanIdForSelectedGroup();
    if (!nextPlanId) return;

    var prev = String(hidden.value || '').trim();
    var next = String(nextPlanId).trim();

    if (!next || prev === next) return;

    hidden.value = next;
    hidden.setAttribute('value', next);
    hidden.dispatchEvent(new Event('input', { bubbles: true }));
    hidden.dispatchEvent(new Event('change', { bubbles: true }));

    console.log('[LV] synced selling_plan from selected group', {
      affiliateMode: isAffiliateMode(),
      previousPlanId: prev,
      nextPlanId: next
    });
  }

  function run() {
    syncSellingPlanInput();
    setTimeout(syncSellingPlanInput, 50);
    setTimeout(syncSellingPlanInput, 250);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (t.closest(GROUP_SEL)) run();
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (t.closest(GROUP_SEL) || t.matches(PLAN_INPUT_SEL)) run();
  }, true);

  window.addEventListener('lv:affiliate_pricing_activated', run);
  window.addEventListener('pageshow', run);

  // if ('MutationObserver' in window) {
  //   var mo = new MutationObserver(function () {
  //     run();
  //   });

  //   mo.observe(document.documentElement, {
  //     childList: true,
  //     subtree: true,
  //     attributes: true,
  //     attributeFilter: ['class', 'aria-checked', 'aria-selected', 'value']
  //   });
  // }
  /* Scoped to the widget, not documentElement. The previous version observed
    the whole document subtree with attribute filters and called run() — which
    schedules three syncs — on every mutation anywhere on the page. With
    OptiMonk, Upcart, Loop and Alpine all mutating the DOM, that was ~2s of
    main-thread time per pageview.

    The widget is what we care about, and it may mount after this file parses,
    so attach when it appears and then stop watching for it. */
    if ('MutationObserver' in window) {
      var widgetMo = null;

      function observeWidget() {
        if (widgetMo) return true;

        var widget = document.querySelector('.loop-widget');
        if (!widget) return false;

        var raf = 0;
        widgetMo = new MutationObserver(function () {
          if (raf) return;
          raf = requestAnimationFrame(function () { raf = 0; run(); });
        });

        widgetMo.observe(widget, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'aria-checked', 'aria-selected', 'value']
        });

        return true;
      }

      if (!observeWidget()) {
        /* Poll briefly for mount rather than observing the document. */
        var tries = 0;
        var mountTimer = setInterval(function () {
          if (observeWidget() || ++tries > 60) clearInterval(mountTimer);
        }, 100);
      }
    }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();